{
  "welcome": {
    "title": "Ti diamo il benvenuto, {{name}}",
    "title_noName": "Benvenuto su Rhemn",
    "body": "Tutto ciò che si illumina ti mostra a cosa serve. Esplora nell'ordine che preferisci, quando vuoi.",
    "start": "Inizia a esplorare",
    "later": "Non ora"
  },
  "card": {
    "tryIt": "Prova",
    "takeALook": "Dai un'occhiata",
    "pro": "Incluso in Rhemn Pro",
    "close_aria": "Chiudi"
  },
  "pill": {
    "progress": "{{count}} di {{total}} esplorati",
    "progress_short": "{{count}} di {{total}}",
    "done": "Fatto",
    "done_aria": "Termina l'esplorazione",
    "complete": "Tutto esplorato"
  },
  "sr": {
    "started": "Modalità esplorazione attiva. I pulsanti mostrano cosa fanno prima di agire.",
    "hint": "Modalità esplorazione. Mostra prima cosa fa.",
    "ended": "Modalità esplorazione disattivata."
  },
  "settings": {
    "row": "Come funziona Rhemn",
    "row_sub": "Uno sguardo veloce a ogni sezione",
    "row_aria": "Come funziona Rhemn: esplora di nuovo l'app",
    "helpCaption": "Aiuto"
  },
  "steps": {
    "intention": {
      "title": "L'intenzione di oggi",
      "body": "Scrivi la cosa più importante di oggi e spuntala quando l'hai fatta."
    },
    "now": {
      "title": "La tua giornata, per preghiere",
      "body": "Rhemn divide la tua giornata a ogni preghiera. Qui vedi il tempo che manca alla prossima e cosa hai pianificato fino ad allora."
    },
    "verse": {
      "title": "Approfondimenti sul versetto",
      "body": "Fai una domanda sul versetto di oggi, leggi un breve tafsir e trova versetti sullo stesso tema."
    },
    "qibla": {
      "title": "Direzione della Qibla",
      "body_chrome": "La direzione della Kaaba da dove ti trovi, in gradi rispetto al nord.",
      "body_ios": "Indica la Kaaba da dove ti trovi. Attiva la bussola in tempo reale e ti segue mentre ti giri."
    },
    "prayer": {
      "title": "Orari di preghiera",
      "body_chrome": "I cinque orari di preghiera di oggi per dove ti trovi. Scegli il metodo di calcolo seguito dalla tua moschea.",
      "body_ios": "La prossima preghiera a colpo d'occhio. Aprila per vedere tutti e cinque gli orari e un promemoria per ciascuno."
    },
    "tasks": {
      "title": "Attività",
      "body": "Organizza le tue attività in liste e dai a ognuna un posto tra le preghiere."
    },
    "notes": {
      "title": "Note",
      "body_chrome": "Scrivi, o parla e basta. Rhemn trascrive le tue note vocali e le riunioni, poi le riassume.",
      "body_ios": "Scrivi, o parla e basta. Rhemn trasforma ciò che dici in note ordinate e riassunte."
    },
    "profile": {
      "title_chrome": "Il tuo profilo",
      "body_chrome": "Le impostazioni dell'account e della privacy. Torna qui per esplorare di nuovo Rhemn.",
      "title_ios": "Altro",
      "body_ios": "Versetti salvati, Qibla e le impostazioni dell'account. Da qui puoi esplorare di nuovo Rhemn."
    }
  }
}
